import { useNavigate } from 'react-router-dom';
import { Icon } from './Icon';
import { haptic } from '@/lib/telegram';

/**
 * Sub-page top bar (drill-down screens). Matches TMA's BackButton position
 * and gives a clean back affordance on plain web/desktop too.
 */
export function Topbar({ title, subtitle, right }: { title: string; subtitle?: string; right?: JSX.Element }): JSX.Element {
  const nav = useNavigate();
  return (
    <div className="mb-5 flex items-center gap-3">
      <button
        className="flex h-10 w-10 items-center justify-center rounded-2xl border border-ink-700/60 bg-ink-850 text-ink-300 active:scale-95"
        onClick={() => { haptic('light'); nav(-1); }}
        aria-label="Назад"
      >
        <Icon name="chevron-left" size={20} />
      </button>
      <div className="min-w-0 flex-1">
        <div className="truncate text-base font-semibold text-ink-50">{title}</div>
        {subtitle && <div className="truncate text-xs text-ink-500">{subtitle}</div>}
      </div>
      {right}
    </div>
  );
}
